<template>
  <div class="gap-4 xl:gap-10 flex items-start xs:items-center w-full">
    <figure class="rounded w-full max-w-28 md:max-w-64 overflow-hidden">
      <template v-if="event.eventImage">
        <img
          loading="lazy"
          class="block w-full bg-gray-100"
          alt="race emblem image"
          :src="event.eventImage"
        >
      </template>

      <template v-else>
        <div class="bg-gray-100 w-full text-center h-full aspect-[4/3] flex items-center justify-center rounded">
          <div>
            <FontAwesomeIcon
              class="block text-gray-500 text-4xl object-center object-cover"
              :icon="faImage"
            />
            <span class="block">No Event Image</span>
          </div>
        </div>
      </template>
    </figure>

    <div>
      <h1 class="text-lg md:text-2xl lg:text-3xl mb-1.5 md:mb-2 leading-snug">
        {{ event.name }}
      </h1>

      <p class="text-secondary">
        <span class="font-semibold">Date: </span>
        {{ dateFormatter.formatShortDate(event.date) }}
        <span class="inline mx-1">|</span>

        <span class="font-semibold">
          Location:
        </span>
        {{ event.location }}
      </p>
    </div>
  </div>
</template>

<script setup>

import { faImage } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { useDateFormatter } from '@/composables';

const dateFormatter = useDateFormatter();

defineProps({
  event: {
    type: Object,
    required: true,
  },
});

</script>
